// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-active {
  background-color: #EDECEC;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
}

.header-default {
  background-color: white;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
}

.section-container {
  margin: 0px 10px;
}

table {
  font-size: 14px;
  width: 100%;
  margin-bottom: 20px;
}

th, td {
  padding: 10px;
}

thead > tr {
  border-bottom: 1px #D7D7D7 solid;
}

table > tbody > tr:nth-child(odd) > td {
  background-color: white !important;
}

table > tbody > tr:nth-child(even) > td {
  background-color: #F6F6F6 !important;
}

table > thead > tr > th {
  background-color: white !important;
}

th {
  font-size: 14px;
  font-weight: normal;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
